import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
	selector: '[uiDropdownContent]',
	standalone: false,
})
export class DropdownContentDirective {
	public template = inject(TemplateRef<any>);
}
